import { useNavigate, useRouteError } from 'react-router';

import { ROUTES } from '@/shared/config';
import { ErrorScreen } from '@/shared/ui';

/**
 * Ошибка внутри маршрута. Сессия и данные живы, поэтому предлагаем
 * вернуться на главную, а не перезагружать мини-апп целиком.
 */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <ErrorScreen
      title="Экран не открылся"
      message="Попробуйте вернуться на главную и открыть раздел заново."
      detail={error instanceof Error ? error.message : undefined}
      actionLabel="На главную"
      onAction={() => {
        void navigate(ROUTES.home);
      }}
    />
  );
}
